export const PaceTypeDropdown = [
  { id: 'TRAFFIC', name: 'Traffic' },
  { id: 'USER', name: 'User' }
]

export const PaceTypes = {
  traffic: 'TRAFFIC', user: 'USER'
}



// WEBPACK FOOTER //
// ./src/views/Common/Partials/StaticData/PaceTypes.tsx